export default "__VITE_ASSET__Beax7295__"